/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React, {useContext, useState, useEffect} from "react";

import {useTypedSelector} from "@Services/Hooks/UseTypedSelector";


import FormFieldsGroupComponent from "@Components/UI/Forms/Group";
import FormFieldsGroupFieldsComponent from "@Components/UI/Forms/Group/Fields";
import FormCheckboxFieldComponent from "@Components/UI/Forms/Field/Checkbox";
import LOGGED_USER_INTERFACE from "@Store/Interfaces/Authentication/User";
import {useDispatch} from "react-redux";
import ApplicationApiContext from "@Contexts/Api";
import CHANGE_API_REQUEST_STATUS_ACTION from "@Actions/Interface/ChangeApiRequestStatus";
import DEFAULT_REQUEST_HEADERS from "@Services/Interfaces/Http/Request/Headers";


export const UserRegistrationRegulationComponent = ({regulationData, index, formUserGeneratedID, regulationsAcceptations, regulationsAcceptationsHandler} : {regulationData: any, index: number, formUserGeneratedID: string, regulationsAcceptations: any, regulationsAcceptationsHandler: any}) => {


    /** @var {DISPATCHER} Global State Actions Dispatcher */
    const DISPATCHER = useDispatch();


    /** @var {REST_API_URL} Global Rest Api Root URL Address */
    const REST_API_URL = useContext(ApplicationApiContext)?.API_ROOT_URL;


    const REST_API_REQUEST_STATUS= useTypedSelector(
        (state):ReturnType<any> => state.interface
    )?.apiRequestStatus;


    const [regulationAcceptedStatus, setRegulationAcceptedStatus] = useState(false);

    const changeRegulationAcceptedStatus = (status: boolean) => {
        setRegulationAcceptedStatus(status);
        regulationsAcceptationsHandler({...regulationsAcceptations, [index]: status});
    };

    const GET_REGULATIONS_FILE = async () => {

        DISPATCHER(CHANGE_API_REQUEST_STATUS_ACTION(true));

        try {

            const RESPONSE = await fetch(`${REST_API_URL}/App/Regulation/Get/Docs`, {
                method: "POST", headers: DEFAULT_REQUEST_HEADERS,
                body: JSON.stringify({
                    UserId: formUserGeneratedID, RegulationId: regulationData?.RegulationId
                })
            });

            if (RESPONSE.status === 200) {
                const CONTENT: any = await RESPONSE.json();
                if (!CONTENT?.Docs[0]?.DocData) return;
                
                const binaryString = window.atob(CONTENT.Docs[0].DocData);
                const len = binaryString.length;
                const bytes = new Uint8Array(len);
                for (let i = 0; i < len; ++i) {
                    bytes[i] = binaryString.charCodeAt(i);
                }

                const PDF = new Blob([bytes], {type: 'application/pdf'});

                const PDF_URL = URL.createObjectURL(PDF);
                window.open(PDF_URL);
            } else {

            }

        } catch (e) {}

        DISPATCHER(CHANGE_API_REQUEST_STATUS_ACTION(false));
    };

    return (
        <>
            <FormCheckboxFieldComponent
                fieldCheckedStatus={regulationAcceptedStatus}
                fieldCheckedStatusHandler={() => changeRegulationAcceptedStatus(!regulationAcceptedStatus)}
                fieldLabel={regulationData.Name}
                fieldLabelClickHandler={GET_REGULATIONS_FILE}
                fieldError={null}
                fieldDisabledStatus={REST_API_REQUEST_STATUS}
            />

        </>
    );

};


export default UserRegistrationRegulationComponent;
